import { render, staticRenderFns } from "./ViewNoteDialog.vue?vue&type=template&id=0206deca&"
import script from "./ViewNoteDialog.vue?vue&type=script&lang=js&"
export * from "./ViewNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports